import { Injectable } from '@angular/core';

import { ofType } from '@ngrx/effects';
import { ActionsSubject, select, Store } from '@ngrx/store';

import { Hub } from '@qwyk/models';

import {
    MagayaNetworkConfigurationEntity,
    CreateMagayaNetworkConfigurationPayload,
    UpdateMagayaNetworkConfigurationPayload,
} from './magaya-network-configuration.models';
import * as MagayaNetworkConfigurationActions from './magaya-network-configuration.actions';
import * as MagayaNetworkConfigurationSelectors from './magaya-network-configuration.selectors';

@Injectable()
export class MagayaNetworkConfigurationFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(
            MagayaNetworkConfigurationSelectors.getMagayaNetworkConfigurationLoading
        )
    );
    error$ = this.store.pipe(
        select(
            MagayaNetworkConfigurationSelectors.getMagayaNetworkConfigurationError
        )
    );
    initialized$ = this.store.pipe(
        select(
            MagayaNetworkConfigurationSelectors.getMagayaNetworkConfigurationInitialized
        )
    );
    magayaNetworkConfiguration$ = this.store.pipe(
        select(
            MagayaNetworkConfigurationSelectors.getMagayaNetworkConfiguration
        )
    );

    updateMagayaNetworkConfigurationSuccessListener$ =
        this.actionsListener$.pipe(
            ofType(
                MagayaNetworkConfigurationActions.updateMagayaNetworkConfigurationSuccess
            )
        );

    constructor(
        private store: Store,
        private actionsListener$: ActionsSubject
    ) {}

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    public init(organization: Hub.Organization) {
        this.store.dispatch(
            MagayaNetworkConfigurationActions.init({ organization })
        );
    }

    public create(payload: CreateMagayaNetworkConfigurationPayload): void {
        this.store.dispatch(
            MagayaNetworkConfigurationActions.createMagayaNetworkConfiguration({
                payload,
            })
        );
    }

    public test(organization: Hub.Organization): void {
        this.store.dispatch(
            MagayaNetworkConfigurationActions.testMagayaNetworkConfiguration({
                organization,
            })
        );
    }

    public update(
        entity: MagayaNetworkConfigurationEntity,
        payload: UpdateMagayaNetworkConfigurationPayload
    ): void {
        this.store.dispatch(
            MagayaNetworkConfigurationActions.updateMagayaNetworkConfiguration({
                entity,
                payload,
            })
        );
    }

    public dismissError(): void {
        this.store.dispatch(MagayaNetworkConfigurationActions.dismissError());
    }
}
